import { render, staticRenderFns } from "./CurrencyInput.vue?vue&type=template&id=5b05cc8e&"
import script from "./CurrencyInput.vue?vue&type=script&lang=js&"
export * from "./CurrencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b05cc8e')) {
      api.createRecord('5b05cc8e', component.options)
    } else {
      api.reload('5b05cc8e', component.options)
    }
    module.hot.accept("./CurrencyInput.vue?vue&type=template&id=5b05cc8e&", function () {
      api.rerender('5b05cc8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CurrencyInput.vue"
export default component.exports